export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
export const FETCH_USER_DELETETOKEN = "FETCH_USER_DELETETOKEN";
export const FETCH_ERROR_DELETE = "FETCH_ERROR_DELETE";
export const FETCH_USER_PAGE = "FETCH_USER_PAGE";
